import React, { Component } from 'react';

class ModgroupDisplay extends Component {
  componentDidMount() {

  }
  render() {
    let pickedModgroups = this.props.pickedModgroups || []
    // opt-in per product (e.g. combo items with one group per pizza): one
    // labeled line per group so the customer can tell the groups apart
    if (this.props.showGroupNames) {
      return(
        <div className="modgroups-checkout-display with-group-names">
          {pickedModgroups.filter(({modifiers=[]}) => modifiers.length > 0).map(({name, modifiers}, i) => (
            <div key={i} className="modgroup-line" style={{margin: '0.25em 0'}}>
              <strong className="group-name">{name}:</strong>{' '}
              {modifiers.map(({name}) => name).join(', ')}
            </div>
          ))}
        </div>
      )
    }
    return(
      <div className="modgroups-checkout-display">
        {pickedModgroups.map(({name, modifiers=[]}) => {
          return(
            <span className="">
              {/* <span className="group-name">{name}</span> */}
              <div className="">
                {modifiers.map(({name, price}) => (

                    <span className="">{name},</span>

                ))}
              </div>
            </span>
          )
        })}
      </div>
    )
  }
}



export default ModgroupDisplay
